import RelatesTo from "./relates-to";
import Task from "./task-column";
import Status from "./status-column";
import Date from "./date-column";

export const TableColumns = {
  RelatesTo,
  Status,
  Task,
  Date,
};
